import {
  PlannerConfigEntity,
  PlannerConfigEntityWithOptionalFields,
} from '@/services/configurator/PlannerConfigTypes';
import { PlannerPageContainer } from './PlannerPageContainer';
import { newUuid } from '@/lib/uuid';
import { hasPermission } from '@/utils/validation';
import { ADD_CTA_PERMISSIONS } from '@/config/feature-permissions';
import { useUser } from '@/components/providers/user-provider';
import { useEnv } from '@/components/providers/env-provider';
import { Staging } from '@/services/configurator/Staging';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export function CreatePlannerPage() {
  const planner = {
    id: newUuid(),
    team: 'rex',
    includeDeeplinkParams: true,
    includeListingSearchParams: true,
    contentPageSectionVisibility: {
      pageSecondaryBanner: true,
      pagePrimaryCard: true,
      pageSecondaryCard: true,
      video: true,
    },
  } as PlannerConfigEntityWithOptionalFields;

  const { role } = useUser();
  const { env } = useEnv();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!hasPermission(ADD_CTA_PERMISSIONS[env], role)) {
    return null;
  }

  async function onSubmit(data: PlannerConfigEntityWithOptionalFields) {
    const staging = new Staging(env);
    try {
      setIsSubmitting(true);
      await Promise.all([staging.getIdentifiers()]).then(
        async (identifiers) => {
          const identifierAlreadyExists =
            data.identifier && identifiers.flat().includes(data.identifier);

          if (identifierAlreadyExists) {
            toast.error(
              `Planner identifier already exist [${data.identifier}]`,
            );
            return;
          }

          await staging
            .addNewPlannerEntry(data as PlannerConfigEntity)
            .then(() => {
              toast.success(`Saved draft [${data.identifier}]`);
              navigate('/');
            });
        },
      );
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <PlannerPageContainer
      mode='create'
      planner={planner}
      title='Create New Planner or Draft'
      description="Create a planner or draft here. Click save when you're done."
      onSubmit={onSubmit}
      disabledFormFields={false}
      disabledPhraseFields={false}
      isSubmitting={isSubmitting}
    />
  );
}
